<template>
  <div class="app-progress-bar-container">
    <div class="app-progress-bar" :style="{width: progress + '%'}"></div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
      validator(value) {
        return value >= 0 && value <= 100;
      },
    },
  },
  watch: {
    progress: {
      handler: function(value) {
        if (value === 100) {
          this.$emit('on-app-progress-bar-completed');
        }
      },
    },
  },
};
</script>

<style scoped>
.app-progress-bar-container {
  width: 100%;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.app-progress-bar {
  height: 100%;
  background-color: #77c8f1;
  transition: width 0.3s ease;
  border-radius: 4px 4px 4px 4px;
}
</style>
